import React from "react";
import { Grid, Paper, Typography, makeStyles, List, ListItemText, ListItem } from "@material-ui/core";

const useStyle = makeStyles(theme => ({
  sb: { width: "100%", height: "80vh" },
  paper: {
    padding: theme.spacing(2),
    textAlign: "left",
    color: theme.palette.text.primary,
    height: "80vh"
  }
}));

export default props => {
  const classes = useStyle();
  return (
    <React.Fragment>
      {props.data.map((sb, idx) => (
        <Grid container key={idx}>
          <Grid item xs={12} md={6}>
            <Paper className={classes.paper}>
              <Typography gutterBottom variant="h4" color="textPrimary">
                {sb.title}
              </Typography>
              <List>
              {sb.steps.map((step, stepIdx) => (
                <ListItem key={stepIdx}>
                    <ListItemText>
                    {`${stepIdx+1}.  ${step}`}
                    </ListItemText>
                </ListItem>
              ))}
              </List>
            </Paper>
          </Grid>
          <Grid item xs={12} md={6}>
            <iframe className={classes.sb} src={sb.url}></iframe>
          </Grid>
        </Grid>
      ))}
    </React.Fragment>
  );
};
